<nav class="navbar">
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="onMemoCreationRequested()">Ajouter un m&eacute;mo</button>
	</div>
</nav>
<div *ngIf="maxSizeExceeded" class="max-exceeded">La liste de r&eacute;sulats a &eacute;t&eacute; limit&eacute;e a {{ maxSize }} &eacute;l&eacute;ments pour raisons de performance</div>
<div class="mat-elevation-z8">
	<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
	<table mat-table matSort [dataSource]="dataSource">
		<ng-container matColumnDef="id">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
			<td mat-cell *matCellDef="let memo"> {{memo.id}} </td>
		</ng-container>
	
		<ng-container matColumnDef="intitule">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Intitul&eacute; </th>
			<td mat-cell *matCellDef="let memo"> {{memo.intitule}} </td>
		</ng-container>
	
		<ng-container matColumnDef="categorie">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Cat&eacute;gorie </th>
			<td mat-cell *matCellDef="let memo"> {{ getCategorieLabel(memo) }} </td>
		</ng-container>
	
		<ng-container matColumnDef="niveau">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Niveau </th>
			<td mat-cell *matCellDef="let memo"> {{ getNiveauLabel(memo) }} </td>
		</ng-container>
	
		<ng-container matColumnDef="parc">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Parc concern&eacute; </th>
			<td mat-cell *matCellDef="let memo"> {{ getParcLabel(memo)}} </td>
		</ng-container>
	
		<ng-container matColumnDef="ouvrages">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Ouvrages concern&eacute;s </th>
			<td mat-cell *matCellDef="let memo"> {{ getOuvragesLabel(memo) }} </td>
		</ng-container>
	
		<ng-container matColumnDef="dateDebut">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Date de d&eacute;but </th>
			<td mat-cell *matCellDef="let memo"> {{ memo.dateDebut | displayLocalDate }} </td>
		</ng-container>
	
		<ng-container matColumnDef="dateFin">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Date de fin </th>
			<td mat-cell *matCellDef="let memo"> {{ memo.dateFin | displayLocalDate }} </td>
		</ng-container>
	
		<ng-container matColumnDef="commentaire">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Commentaire </th>
			<td mat-cell *matCellDef="let memo"> {{memo.commentaire}} </td>
		</ng-container>
	
		<ng-container matColumnDef="commentaire">
			<th mat-header-cell *matHeaderCellDef>&nbsp;</th>
			<td mat-cell *matCellDef="let memo">
				<a alt="Modifier" title="Modifier"
					[ngClass]="memo.archived || parcInactif(memo) ? 'icon-button-white' : 'icon-button-blue'"
					href="#"
					onclick="return false;"
					(click)="onMemoUpdateRequested(memo)"
					>
					<i class="fa-solid fa-pen-to-square"></i>
				</a>
				&nbsp;
				<a alt="Supprimer" title="Supprimer"
					href="#"
					class="icon-button-red"
					onclick="return false;"
					(click)="onMemoDeletionRequested(memo)"
					>
					<i class="fa fa-trash"></i>
				</a>
				&nbsp;
				<a alt="Archiver" title="Archiver"
					href="#"
					[ngClass]="memo.archived ? 'icon-button-gray' : 'icon-button-black'"
					onclick="return false;"
					(click)="onMemoArchivingRequested(memo)"
					>
					<i class="fa fa-archive"></i>
				</a>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
	</table>
	<mat-paginator #paginator
		showFirstLastButtons
		[pageSizeOptions]="[5, 10, 20, 50]"
		[pageSize]="10"
		aria-label="Choisissez une page">
	</mat-paginator>
</div>

<edit-memo-dialog
	(memoCreate)="onMemoCreate()"
	(memoUpdate)="onMemoUpdate()"
	(memoArchive)="onMemoArchive()"
	>
</edit-memo-dialog>